module.exports = __webpack_public_path__ + "static/media/delete.dc2160b7.svg";